import { render, staticRenderFns } from "./shareB.vue?vue&type=template&id=2e443560&scoped=true&"
import script from "./shareB.vue?vue&type=script&lang=js&"
export * from "./shareB.vue?vue&type=script&lang=js&"
import style0 from "./shareB.vue?vue&type=style&index=0&id=2e443560&scoped=true&lang=scss&"
import style1 from "./shareB.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e443560",
  null
  
)

export default component.exports